<p-toast></p-toast>
<p-confirmDialog header="Atenção" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="me" *ngIf="info && modelo">
  <div class="me-fixo">
  <header class="me-topo">
    <button pButton type="button" icon="pi pi-arrow-left" class="p-button-text p-button-rounded p-button-secondary" aria-label="Voltar para a lista"
      (click)="voltar()"></button>
    <div class="me-identidade">
      <h1>{{ modelo.titulo || info.titulo }}</h1>
      <div class="me-identidade-meta">
        <code>{{ modelo.chave || info.chave }}</code>
        <span [class]="'situacao situacao-' + (alterado || info.temRascunho ? 'rascunho' : (info.situacao || 'RASCUNHO').toLowerCase())">{{ rotuloSituacao }}</span>
        <span class="situacao situacao-piloto" *ngIf="info.versaoPiloto">Piloto v{{ info.versaoPiloto }}</span>
        <span class="me-nao-salvo" *ngIf="alterado"><i></i>alterações não salvas</span>
      </div>
    </div>
    <habil-seletor-base></habil-seletor-base>
    <button pButton type="button" class="p-button-text p-button-secondary" icon="pi pi-check-square" label="Validar" (click)="validar()"></button>
    <button pButton type="button" class="p-button-outlined" icon="pi pi-bolt" label="Ajustar com IA" *ngIf="podeEditar" (click)="mostrarIa = true"></button>
    <button pButton type="button" class="p-button-outlined" icon="pi pi-play" label="Prévia" (click)="abrirPrevia()"></button>
    <button pButton type="button" class="p-button-outlined" label="Salvar rascunho" *ngIf="podeEditar" [disabled]="!!ocupado" (click)="salvarRascunho()"></button>
    <button pButton type="button" icon="pi pi-send" [label]="'Publicar v' + proximaVersao" *ngIf="podePublicar" [disabled]="!!ocupado" (click)="abrirPublicar()"></button>
  </header>

  <p-progressBar *ngIf="ocupado" mode="indeterminate" [style]="{ height: '3px' }"></p-progressBar>

  <div class="rd-info me-piloto" *ngIf="info.versaoPiloto">
    <span>
      A v{{ info.versaoPiloto }} está em piloto para {{ info.cnpjsPiloto?.length }}
      {{ info.cnpjsPiloto?.length === 1 ? 'cliente' : 'clientes' }} ({{ info.cnpjsPiloto?.join(', ') }}).
      <ng-container *ngIf="info.versaoPublicada">Os demais seguem na v{{ info.versaoPublicada }}.</ng-container>
      <ng-container *ngIf="!info.versaoPublicada">Ninguém mais recebe o modelo ainda.</ng-container>
    </span>
    <ng-container *ngIf="podePublicar">
      <button pButton type="button" class="p-button-sm" label="Abrir para todos" (click)="abrirParaTodos()"></button>
      <button pButton type="button" class="p-button-sm p-button-outlined" label="Encerrar piloto" (click)="encerrarPiloto()"></button>
    </ng-container>
  </div>

  <nav class="rd-abas me-abas" role="tablist" aria-label="Partes do modelo">
    <button type="button" role="tab" *ngFor="let a of abas" [class.ativa]="aba === a.id" [attr.aria-selected]="aba === a.id" [disabled]="a.breve"
      [title]="a.breve ? 'Em breve: o motor ainda não desenha ' + a.nome.toLowerCase() : ''" (click)="trocarAba(a.id)">
      {{ a.nome }}
      <span class="me-contador" *ngIf="a.contador && a.contador()">{{ a.contador() }}</span>
      <span class="me-breve" *ngIf="a.breve">em breve</span>
    </button>
  </nav>
  </div>

  <div class="me-bancada" *ngIf="abaComPainel">
    <section class="rd-painel me-fonte" #painelFonte aria-label="Colunas da fonte">
      <div class="me-fonte-topo">
        <div>
          <div class="rd-painel-titulo">Colunas da fonte</div>
          <div class="me-fonte-chave" *ngIf="fonteAtual"><code>{{ fonteAtual.chave }} v{{ fonteAtual.versao }}</code></div>
        </div>
        <a href="javascript:void(0)" *ngIf="fonteAtual" (click)="abrirFonte()">Abrir fonte</a>
      </div>
      <div class="me-fonte-vazia" *ngIf="!fonteAtual">
        A fonte <code>{{ modelo.fonte || '—' }}</code> não tem versão salva. Escolha a fonte na aba <a href="javascript:void(0)" (click)="trocarAba('dados')">Dados</a>.
      </div>
      <ng-container *ngIf="fonteAtual">
        <p class="me-dica">{{ dicaColuna }}</p>
        <span class="p-input-icon-left me-busca">
          <i class="pi pi-search"></i>
          <input type="text" pInputText placeholder="Buscar coluna" [(ngModel)]="buscaColuna" aria-label="Buscar coluna" />
        </span>
        <div class="me-fonte-rolagem">
          <div class="me-lista">
            <button type="button" class="me-coluna" *ngFor="let c of colunasFonte" [disabled]="!podeEditar" (click)="usarColuna(c)"
              [title]="c.descricao || ''">
              <span class="me-tipo">{{ c.tipo }}</span>
              <span class="me-coluna-nome">
                <span>{{ c.rotulo || c.nome }}</span>
                <code>{{ c.nome }}</code>
              </span>
              <span class="me-usos" *ngIf="usosColuna(c.nome).length" [title]="'Usada em: ' + usosColuna(c.nome).join(', ')">
                <i class="pi pi-check"></i>
              </span>
              <span class="me-sensivel" *ngIf="c.sensivel" title="Dado sensível">sensível</span>
            </button>
          </div>
          <ng-container *ngIf="variaveisFonte.length">
            <div class="rd-painel-titulo me-fonte-subtitulo">Variáveis da fonte</div>
            <div class="me-lista me-lista-variaveis">
              <button type="button" class="me-coluna" *ngFor="let v of variaveisFonte" [disabled]="!podeEditar" (click)="usarVariavel(v)"
                [title]="aba === 'indicadores' ? 'Criar um indicador com esta variável' : 'Mostrar esta variável no relatório'">
                <span class="me-tipo me-tipo-variavel">variável</span>
                <span class="me-coluna-nome">
                  <span>{{ v.rotulo }}</span>
                  <code>{{ v.descricao }}</code>
                </span>
                <span class="me-usos" *ngIf="variavelUsada(v.nome)"><i class="pi pi-check"></i></span>
              </button>
            </div>
          </ng-container>
        </div>
      </ng-container>
    </section>

    <main class="me-centro">
      <section class="rd-painel me-secao" *ngIf="aba === 'dados'">
        <div class="rd-painel-titulo">Dados do modelo</div>
        <div class="me-form-grade">
          <div class="me-campo me-campo-largo">
            <label for="m-titulo">Título</label>
            <input id="m-titulo" type="text" pInputText [(ngModel)]="modelo.titulo" [disabled]="!podeEditar" />
          </div>
          <div class="me-campo">
            <label for="m-chave">Chave</label>
            <input id="m-chave" type="text" pInputText class="me-mono" [(ngModel)]="modelo.chave" [disabled]="!podeEditar || !!info.versaoPublicada" />
            <small *ngIf="info.versaoPublicada">Não muda depois de publicado: o catálogo dos clientes usa a chave.</small>
          </div>
          <div class="me-campo">
            <label for="m-categoria">Categoria</label>
            <p-dropdown inputId="m-categoria" [options]="opcoesCategoria" [(ngModel)]="categoriaId" [showClear]="true" placeholder="Sem categoria"
              appendTo="body" [filter]="true" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
          </div>
          <div class="me-campo me-campo-largo">
            <label for="m-descricao">Descrição</label>
            <textarea id="m-descricao" pInputTextarea rows="2" [ngModel]="modelo.descricao" (ngModelChange)="definir(modelo, 'descricao', $event)"
              [disabled]="!podeEditar" placeholder="O que o relatório mostra, em uma frase. Aparece no catálogo do cliente."></textarea>
          </div>
          <div class="me-campo me-campo-largo">
            <label for="m-fonte">Fonte</label>
            <p-dropdown inputId="m-fonte" [options]="opcoesFonte" [(ngModel)]="modelo.fonte" [filter]="true" appendTo="body" placeholder="Escolha a fonte"
              [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
            <small>Ao trocar de fonte, confira colunas, filtros e agrupamentos: eles citam as colunas pelo nome.</small>
          </div>
          <div class="me-campo me-campo-largo">
            <label for="m-substitui">Relatórios Jasper que este modelo substitui</label>
            <p-chips inputId="m-substitui" [ngModel]="modelo.substitui || vazio" (ngModelChange)="definir(modelo, 'substitui', $event)" [allowDuplicate]="false"
              [addOnBlur]="true" [disabled]="!podeEditar" styleClass="me-cheio"></p-chips>
            <small>Só registra de onde o modelo veio. Não esconde nem altera o Jasper.</small>
          </div>
        </div>
      </section>

      <section class="rd-painel me-secao" *ngIf="aba === 'filtros'">
        <div class="me-secao-topo">
          <div>
            <div class="rd-painel-titulo">Filtros que o usuário vê</div>
            <p class="me-dica">A empresa vem sempre da base. O que não estiver aqui usa o padrão da fonte, sem o usuário escolher.</p>
          </div>
        </div>

        <div class="me-vazio-bloco" *ngIf="!modelo.filtros.length">Nenhum filtro. O relatório roda direto com os padrões da fonte.</div>

        <div class="me-filtros-grade" *ngIf="modelo.filtros.length">
        <article class="me-cartao me-cartao-filtro" *ngFor="let f of modelo.filtros; let i = index">
          <div class="me-cartao-topo">
            <div class="me-ordem">
              <button type="button" aria-label="Subir" [disabled]="!podeEditar || i === 0" (click)="mover(modelo.filtros, i, -1)"><i class="pi pi-chevron-up"></i></button>
              <button type="button" aria-label="Descer" [disabled]="!podeEditar || i === modelo.filtros.length - 1" (click)="mover(modelo.filtros, i, 1)"><i class="pi pi-chevron-down"></i></button>
            </div>
            <div class="me-filtro-titulo">
              <strong>{{ rotuloFiltro(f) }}</strong>
              <code>{{ f.parametro ? ':' + f.parametro : 'coluna ' + f.coluna }} · {{ tipoFiltro(f).replace('faixa:', 'faixa de ') }}</code>
            </div>
            <label class="me-marca" *ngIf="f.coluna">
              <p-checkbox [binary]="true" [ngModel]="!!f.multiplo" (ngModelChange)="definir(f, 'multiplo', $event || null)" [disabled]="!podeEditar"></p-checkbox>
              Várias
            </label>
            <label class="me-marca">
              <p-checkbox [binary]="true" [ngModel]="obrigatorio(f)" (ngModelChange)="f.obrigatorio = $event" [disabled]="!podeEditar"></p-checkbox>
              Obrigatório
            </label>
            <button type="button" class="me-remover" aria-label="Remover filtro" [disabled]="!podeEditar" (click)="remover(modelo.filtros, i)"><i class="pi pi-times"></i></button>
          </div>
          <div class="me-form-grade">
            <div class="me-campo">
              <label [for]="'f-rot-' + i">Rótulo</label>
              <input [id]="'f-rot-' + i" type="text" pInputText [ngModel]="f.rotulo" (ngModelChange)="definir(f, 'rotulo', $event)"
                [placeholder]="rotuloPadraoFiltro(f)" [disabled]="!podeEditar" />
            </div>
            <div class="me-campo" [ngSwitch]="tipoFiltro(f).startsWith('faixa:') ? 'faixa' : (opcoesParametro(f).length ? 'opcoes' : tipoFiltro(f))">
              <label [for]="'f-pad-' + i">Valor inicial</label>
              <p-dropdown *ngSwitchCase="'periodo'" [inputId]="'f-pad-' + i" [options]="opcoesPeriodo" [ngModel]="f.padrao"
                (ngModelChange)="definir(f, 'padrao', $event)" [showClear]="true" [placeholder]="padraoDaFonte(f) || 'Escolha'" appendTo="body"
                [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
              <p-dropdown *ngSwitchCase="'opcoes'" [inputId]="'f-pad-' + i" [options]="opcoesParametro(f)" [ngModel]="f.padrao"
                (ngModelChange)="definir(f, 'padrao', $event)" [showClear]="true" [placeholder]="padraoDaFonte(f) || 'Escolha'" appendTo="body"
                [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
              <p-dropdown *ngSwitchCase="'booleano'" [inputId]="'f-pad-' + i" [options]="opcoesBooleano" [ngModel]="f.padrao"
                (ngModelChange)="definir(f, 'padrao', $event)" [showClear]="true" [placeholder]="padraoDaFonte(f) || 'Escolha'" appendTo="body"
                [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
              <input *ngSwitchCase="'data'" [id]="'f-pad-' + i" type="date" pInputText [ngModel]="f.padrao" (ngModelChange)="definir(f, 'padrao', $event)"
                [disabled]="!podeEditar" />
              <input *ngSwitchCase="'inteiro'" [id]="'f-pad-' + i" type="number" pInputText [ngModel]="f.padrao" (ngModelChange)="definirPadraoNumero(f, $event)"
                [placeholder]="padraoDaFonte(f)" [disabled]="!podeEditar" />
              <input *ngSwitchCase="'decimal'" [id]="'f-pad-' + i" type="number" step="any" pInputText [ngModel]="f.padrao"
                (ngModelChange)="definirPadraoNumero(f, $event)" [placeholder]="padraoDaFonte(f)" [disabled]="!podeEditar" />
              <p-chips *ngSwitchCase="'listaTexto'" [inputId]="'f-pad-' + i" [ngModel]="f.padrao || vazio" (ngModelChange)="definir(f, 'padrao', $event)"
                [addOnBlur]="true" [allowDuplicate]="false" [disabled]="!podeEditar" styleClass="me-cheio"></p-chips>
              <p-chips *ngSwitchCase="'listaInteiro'" [inputId]="'f-pad-' + i" [ngModel]="f.padrao || vazio" (ngModelChange)="definir(f, 'padrao', $event)"
                [addOnBlur]="true" [allowDuplicate]="false" [disabled]="!podeEditar" styleClass="me-cheio"></p-chips>
              <span *ngSwitchCase="'faixa'" class="me-sem-padrao">O usuário informa de/até ao rodar.</span>
              <input *ngSwitchDefault [id]="'f-pad-' + i" type="text" pInputText [ngModel]="f.padrao" (ngModelChange)="definir(f, 'padrao', $event)"
                [placeholder]="padraoDaFonte(f)" [disabled]="!podeEditar" />
            </div>
          </div>
        </article>
        </div>

        <div class="me-adicionar" *ngIf="podeEditar">
          <div class="me-adicionar-linha" *ngIf="parametrosForaDosFiltros.length">
            <span>Parâmetros da fonte sem filtro:</span>
            <button type="button" class="me-pilula" *ngFor="let p of parametrosForaDosFiltros" (click)="adicionarFiltroParametro(p.nome)">
              <i class="pi pi-plus"></i>{{ p.rotulo || p.nome }} <code>:{{ p.nome }}</code>
            </button>
          </div>
          <div class="me-adicionar-linha">
            <span>Filtrar por uma coluna:</span>
            <p-dropdown [options]="colunasSemFiltro" [ngModel]="null" (ngModelChange)="adicionarFiltroColuna($event)" placeholder="Escolha a coluna"
              [filter]="true" appendTo="body" styleClass="me-adicionar-dropdown"></p-dropdown>
          </div>
          <div class="me-adicionar-linha">
            <span>Esconder linhas sem:</span>
            <p-multiSelect *ngIf="!filtrosFixosProprios" [options]="opcoesColuna" [ngModel]="colunasComValor" (ngModelChange)="definirColunasComValor($event)"
              placeholder="Mostrar todas as linhas" [filter]="true" [maxSelectedLabels]="2" selectedItemsLabel="{0} colunas" appendTo="body"
              styleClass="me-adicionar-dropdown"></p-multiSelect>
            <span *ngIf="filtrosFixosProprios">há uma regra fixa escrita na aba JSON; ajuste por lá.</span>
          </div>
        </div>
      </section>

      <section class="rd-painel me-secao" *ngIf="aba === 'colunas'">
        <div class="me-secao-topo">
          <div>
            <div class="rd-painel-titulo">Colunas do relatório</div>
            <p class="me-dica">Na ordem em que aparecem. O rótulo em branco usa o da fonte.</p>
          </div>
          <p-dropdown *ngIf="podeEditar" [options]="colunasForaDoRelatorio" [ngModel]="null" (ngModelChange)="adicionarColuna($event)"
            placeholder="Adicionar coluna" [filter]="true" appendTo="body" styleClass="me-adicionar-dropdown"></p-dropdown>
        </div>

        <div class="me-vazio-bloco" *ngIf="!modelo.colunas.length">Nenhuma coluna. Clique numa coluna da fonte, à esquerda.</div>

        <div class="me-tabela" *ngIf="modelo.colunas.length">
          <div class="me-tabela-cabeca me-linha-coluna">
            <span></span><span>Coluna</span><span>Rótulo</span><span>Formato</span><span>Total</span><span title="Mostra numa linha embaixo do item, só quando preenchida">Embaixo</span><span></span>
          </div>
          <div class="me-linha-coluna" *ngFor="let c of modelo.colunas; let i = index">
            <div class="me-ordem">
              <button type="button" aria-label="Subir" [disabled]="!podeEditar || i === 0" (click)="mover(modelo.colunas, i, -1)"><i class="pi pi-chevron-up"></i></button>
              <button type="button" aria-label="Descer" [disabled]="!podeEditar || i === modelo.colunas.length - 1" (click)="mover(modelo.colunas, i, 1)"><i class="pi pi-chevron-down"></i></button>
            </div>
            <div class="me-coluna-nome">
              <span>{{ rotuloColuna(c.coluna) }}</span>
              <code>{{ c.coluna }} · {{ tipoColuna(c.coluna) || 'fora da fonte' }}</code>
            </div>
            <input type="text" pInputText [ngModel]="c.rotulo" (ngModelChange)="definir(c, 'rotulo', $event)" [placeholder]="rotuloColuna(c.coluna)"
              [attr.aria-label]="'Rótulo de ' + rotuloColuna(c.coluna)" [disabled]="!podeEditar" />
            <p-dropdown [options]="opcoesFormato" [ngModel]="c.formato || null" (ngModelChange)="definir(c, 'formato', $event)" appendTo="body"
              [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
            <p-dropdown [options]="opcoesTotal" [ngModel]="c.total || null" (ngModelChange)="definir(c, 'total', $event)" appendTo="body"
              [disabled]="!podeEditar || c.abaixo" styleClass="me-cheio"></p-dropdown>
            <button type="button" role="switch" class="me-chave me-chave-pequena" [attr.aria-checked]="!!c.abaixo"
              [attr.aria-label]="'Mostrar ' + rotuloColuna(c.coluna) + ' numa linha embaixo do item'" [disabled]="!podeEditar"
              title="Mostra numa linha embaixo do item, só quando preenchida (ex.: observação)"
              (click)="definir(c, 'abaixo', c.abaixo ? null : true); c.abaixo && definir(c, 'total', null)"><span></span></button>
            <button type="button" class="me-remover" [attr.aria-label]="'Remover ' + rotuloColuna(c.coluna)" [disabled]="!podeEditar"
              (click)="remover(modelo.colunas, i)"><i class="pi pi-times"></i></button>
          </div>
        </div>

        <div class="me-separador"></div>

        <div class="me-secao-topo">
          <div>
            <div class="rd-painel-titulo">Ordem das linhas</div>
            <p class="me-dica">Sem ordem definida, as linhas vêm na ordem da fonte.</p>
          </div>
          <p-dropdown *ngIf="podeEditar" [options]="colunasSemOrdenacao" [ngModel]="null" (ngModelChange)="adicionarOrdenacao($event)"
            placeholder="Ordenar por" [filter]="true" appendTo="body" styleClass="me-adicionar-dropdown"></p-dropdown>
        </div>
        <div class="me-linha-ordem" *ngFor="let o of modelo.ordenacao; let i = index">
          <div class="me-ordem">
            <button type="button" aria-label="Subir" [disabled]="!podeEditar || i === 0" (click)="mover(modelo.ordenacao, i, -1)"><i class="pi pi-chevron-up"></i></button>
            <button type="button" aria-label="Descer" [disabled]="!podeEditar || i === modelo.ordenacao.length - 1" (click)="mover(modelo.ordenacao, i, 1)"><i class="pi pi-chevron-down"></i></button>
          </div>
          <span class="me-linha-ordem-nome">{{ i + 1 }}. {{ rotuloColuna(o.coluna) }}</span>
          <p-selectButton [options]="opcoesDirecaoLinha" [(ngModel)]="o.direcao" optionLabel="label" optionValue="value" [disabled]="!podeEditar"></p-selectButton>
          <button type="button" class="me-remover" aria-label="Remover ordenação" [disabled]="!podeEditar" (click)="remover(modelo.ordenacao, i)"><i class="pi pi-times"></i></button>
        </div>
      </section>

      <section class="rd-painel me-secao" *ngIf="aba === 'agrupamentos'">
        <div class="me-previa-grupos" aria-label="Como a tabela vai ficar">
          <div class="me-previa-titulo">Como a tabela vai ficar</div>
          <div class="me-previa-linha" *ngFor="let n of previaGrupos" [style.padding-left.px]="n.nivel * 22">
            <i class="pi" [ngClass]="n.icone"></i>
            <span class="me-previa-nome">{{ n.nome }}</span>
            <span class="me-previa-extra" *ngIf="n.extra">{{ n.extra }}</span>
          </div>
        </div>

        <div class="me-passo">
          <span class="me-passo-numero">1</span>
          <div>
            <div class="rd-painel-titulo">Agrupar as linhas</div>
            <p class="me-dica">Junta as linhas com o mesmo valor numa linha de grupo, que abre e fecha. Até 3 níveis, um dentro do outro.</p>
          </div>
        </div>
        <div class="me-vazio-bloco" *ngIf="!modelo.agrupamentos.length">Sem agrupamento: a tabela mostra as linhas soltas.</div>

        <article class="me-cartao" *ngFor="let a of modelo.agrupamentos; let i = index">
          <div class="me-cartao-topo">
            <span class="me-nivel">{{ i + 1 }}</span>
            <p-dropdown [options]="opcoesColuna" [(ngModel)]="a.coluna" [filter]="true" appendTo="body" [disabled]="!podeEditar" styleClass="me-nivel-coluna"></p-dropdown>
            <div class="me-ordem">
              <button type="button" aria-label="Subir nível" [disabled]="!podeEditar || i === 0" (click)="mover(modelo.agrupamentos, i, -1)"><i class="pi pi-chevron-up"></i></button>
              <button type="button" aria-label="Descer nível" [disabled]="!podeEditar || i === modelo.agrupamentos.length - 1" (click)="mover(modelo.agrupamentos, i, 1)"><i class="pi pi-chevron-down"></i></button>
            </div>
            <button type="button" class="me-remover" aria-label="Remover nível" [disabled]="!podeEditar" (click)="remover(modelo.agrupamentos, i)"><i class="pi pi-times"></i></button>
          </div>
          <div class="me-form-grade">
            <div class="me-campo">
              <label [for]="'g-rot-' + i">Rótulo</label>
              <input [id]="'g-rot-' + i" type="text" pInputText [ngModel]="a.rotulo" (ngModelChange)="definir(a, 'rotulo', $event)"
                [placeholder]="rotuloColuna(a.coluna)" [disabled]="!podeEditar" />
            </div>
            <div class="me-campo">
              <label [for]="'g-ord-' + i">Ordenar grupos por</label>
              <p-dropdown [inputId]="'g-ord-' + i" [options]="opcoesOrdenarGrupo" [ngModel]="ordemGrupo(a)" (ngModelChange)="definirOrdemGrupo(a, $event)"
                appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
            </div>
            <div class="me-campo" *ngIf="a.ordenarPor">
              <span class="me-rotulo">Direção</span>
              <p-selectButton [options]="opcoesDirecao" [(ngModel)]="a.ordenarPor.direcao" optionLabel="label" optionValue="value" [disabled]="!podeEditar"></p-selectButton>
            </div>
            <div class="me-campo">
              <span class="me-rotulo">Ao abrir</span>
              <p-selectButton [options]="opcoesAoAbrir" [ngModel]="!!a.recolhido" (ngModelChange)="definir(a, 'recolhido', $event || null)" optionLabel="label"
                optionValue="value" [disabled]="!podeEditar"></p-selectButton>
            </div>
          </div>
        </article>

        <div class="me-soltar" *ngIf="podeEditar && modelo.agrupamentos.length < 3">
          <span>Clique numa coluna à esquerda ou escolha aqui para criar o nível {{ modelo.agrupamentos.length + 1 }}</span>
          <p-dropdown [options]="opcoesNivel" [ngModel]="null" (ngModelChange)="adicionarNivel($event)" placeholder="Escolha a coluna" [filter]="true"
            appendTo="body" styleClass="me-adicionar-dropdown"></p-dropdown>
        </div>

        <div class="me-separador"></div>

        <div class="me-passo">
          <span class="me-passo-numero">2</span>
          <div>
            <div class="rd-painel-titulo">Calcular nas colunas</div>
            <p class="me-dica">O que calcular em cada coluna. O resultado aparece na linha de cada grupo e no total geral. Deixe "Nenhum" nas colunas de texto. Valor que se repete em todas as linhas do grupo (ex.: total da OS em cada item) usa "Soma, uma vez por grupo", para não somar repetido.</p>
          </div>
        </div>
        <div class="me-vazio-bloco" *ngIf="!modelo.colunas.length">Mostre colunas na aba Colunas para definir os cálculos.</div>
        <div class="me-totais" *ngIf="modelo.colunas.length">
          <div class="me-totais-cabecalho"><span>Coluna</span><span>Cálculo</span></div>
          <div class="me-linha-total" *ngFor="let c of modelo.colunas">
            <span>{{ c.rotulo || rotuloColuna(c.coluna) }}</span>
            <p-dropdown [options]="opcoesTotal" [ngModel]="c.total || null" (ngModelChange)="definir(c, 'total', $event)" appendTo="body"
              [disabled]="!podeEditar" styleClass="me-total"></p-dropdown>
          </div>
        </div>
        <div class="me-separador"></div>

        <div class="me-passo">
          <span class="me-passo-numero">3</span>
          <div>
            <div class="rd-painel-titulo">Variáveis</div>
            <p class="me-dica">Cálculos com nome próprio criados na fonte. Não mexem nas colunas: escolha se cada uma aparece ao lado do nome do grupo, na linha do total geral ou nos dois.</p>
          </div>
        </div>
        <div class="me-vazio-bloco" *ngIf="!variaveisFonte.length">
          A fonte não tem variáveis. Crie na aba Variáveis da <a href="javascript:void(0)" *ngIf="fonteAtual" (click)="abrirFonte()">fonte</a><span *ngIf="!fonteAtual">fonte</span> e salve uma versão.
        </div>
        <div class="me-totais" *ngIf="variaveisFonte.length">
          <div class="me-totais-cabecalho me-variaveis-cabecalho"><span>Variável</span><span>Linha do grupo</span><span>Total geral</span></div>
          <div class="me-linha-total me-linha-variavel" *ngFor="let v of variaveisFonte">
            <span class="me-variavel-nome">{{ v.rotulo }} <small>{{ v.descricao }}</small></span>
            <span class="me-variavel-chave">
              <button type="button" role="switch" class="me-chave" [attr.aria-checked]="!!variavelNoModelo(v.nome)?.grupo"
                [attr.aria-label]="'Mostrar ' + v.rotulo + ' na linha do grupo'" [disabled]="!podeEditar" (click)="alternarVariavel(v.nome, 'grupo')"><span></span></button>
            </span>
            <span class="me-variavel-chave">
              <button type="button" role="switch" class="me-chave" [attr.aria-checked]="!!variavelNoModelo(v.nome)?.totalGeral"
                [attr.aria-label]="'Mostrar ' + v.rotulo + ' no total geral'" [disabled]="!podeEditar" (click)="alternarVariavel(v.nome, 'totalGeral')"><span></span></button>
            </span>
          </div>
        </div>

        <div class="me-linha-total me-linha-geral">
          <span>Mostrar a linha <strong>Total geral</strong> no fim da tabela</span>
          <button type="button" role="switch" class="me-chave" [attr.aria-checked]="totalGeral" aria-label="Mostrar a linha Total geral no fim da tabela" [disabled]="!podeEditar"
            (click)="totalGeral = !totalGeral"><span></span></button>
        </div>
      </section>

      <section class="rd-painel me-secao" *ngIf="aba === 'indicadores'">
        <div class="me-secao-topo">
          <div>
            <div class="rd-painel-titulo">Indicadores</div>
            <p class="me-dica">Números grandes em destaque, calculados sobre todas as linhas filtradas.</p>
          </div>
          <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-plus" label="Adicionar indicador" *ngIf="podeEditar"
            (click)="adicionarIndicador()"></button>
        </div>

        <div class="me-linha-total me-posicao" *ngIf="modelo.indicadores.length">
          <span>Onde os indicadores aparecem no relatório</span>
          <p-selectButton [options]="opcoesPosicaoIndicadores" [ngModel]="posicaoIndicadores" (ngModelChange)="definirPosicaoIndicadores($event)"
            optionLabel="label" optionValue="value" [disabled]="!podeEditar"></p-selectButton>
        </div>

        <div class="me-vazio-bloco" *ngIf="!modelo.indicadores.length">Nenhum indicador. Clique numa coluna numérica à esquerda para criar um com a soma dela.</div>

        <div class="me-grade-cartoes" *ngIf="modelo.indicadores.length">
          <article class="me-cartao" *ngFor="let ind of modelo.indicadores; let i = index" [class.me-cartao-metade]="ind.largura === 'metade'">
            <div class="me-cartao-topo">
              <div class="me-ordem">
                <button type="button" aria-label="Subir" [disabled]="!podeEditar || i === 0" (click)="mover(modelo.indicadores, i, -1)"><i class="pi pi-chevron-up"></i></button>
                <button type="button" aria-label="Descer" [disabled]="!podeEditar || i === modelo.indicadores.length - 1" (click)="mover(modelo.indicadores, i, 1)"><i class="pi pi-chevron-down"></i></button>
              </div>
              <div class="me-cartao-titulo">
                <strong>{{ ind.rotulo || 'Sem rótulo' }}</strong>
                <span class="me-selo">{{ ind.id }}</span>
              </div>
              <p-selectButton [options]="opcoesTipoIndicador" [ngModel]="tipoIndicador(ind)" (ngModelChange)="definirTipoIndicador(ind, $event)" optionLabel="label"
                optionValue="value" [disabled]="!podeEditar"></p-selectButton>
              <p-selectButton class="me-largura" [options]="opcoesLargura" [ngModel]="ind.largura || 'inteira'" (ngModelChange)="definirLarguraIndicador(ind, $event)"
                optionLabel="label" optionValue="value" [disabled]="!podeEditar">
                <ng-template let-item pTemplate>
                  <span class="me-largura-icone" [class.me-largura-icone-metade]="item.value === 'metade'" [title]="'Largura ' + item.label.toLowerCase()"
                    [attr.aria-label]="'Largura ' + item.label.toLowerCase()"><i></i><i></i></span>
                </ng-template>
              </p-selectButton>
              <button type="button" class="me-remover" aria-label="Remover indicador" [disabled]="!podeEditar" (click)="remover(modelo.indicadores, i)"><i class="pi pi-times"></i></button>
            </div>
            <div class="me-form-grade">
              <div class="me-campo">
                <label [for]="'i-rot-' + i">Rótulo</label>
                <input [id]="'i-rot-' + i" type="text" pInputText [ngModel]="ind.rotulo" (ngModelChange)="definirRotuloIndicador(ind, $event)" [disabled]="!podeEditar" />
              </div>
              <ng-container *ngIf="ind.metrica">
                <div class="me-campo">
                  <label [for]="'i-fun-' + i">Cálculo</label>
                  <p-dropdown [inputId]="'i-fun-' + i" [options]="opcoesFuncao" [(ngModel)]="ind.metrica.funcao" appendTo="body" [disabled]="!podeEditar"
                    styleClass="me-cheio"></p-dropdown>
                </div>
                <div class="me-campo">
                  <label [for]="'i-col-' + i">Coluna</label>
                  <p-dropdown [inputId]="'i-col-' + i" [options]="opcoesColuna" [ngModel]="ind.metrica.coluna || null" (ngModelChange)="definir(ind.metrica, 'coluna', $event)"
                    [showClear]="ind.metrica.funcao === 'COUNT'" [placeholder]="ind.metrica.funcao === 'COUNT' ? 'Todas as linhas' : 'Escolha'" [filter]="true"
                    appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
                </div>
              </ng-container>
              <div class="me-campo" *ngIf="!ind.metrica && !ind.calculo">
                <label [for]="'i-var-' + i">Variável</label>
                <p-dropdown [inputId]="'i-var-' + i" [options]="opcoesVariavel" [ngModel]="ind.variavel || null" (ngModelChange)="definir(ind, 'variavel', $event)"
                  placeholder="Escolha" emptyMessage="A fonte não tem variáveis" appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
              </div>
              <ng-container *ngIf="ind.calculo">
                <p class="me-dica me-campo-largo">
                  Divide um indicador por outro que esteja acima deste. Ex.: Total vendido ÷ Quantidade de vendas = Ticket médio.
                </p>
                <div class="me-campo">
                  <label [for]="'i-div-' + i">Dividir</label>
                  <p-dropdown [inputId]="'i-div-' + i" [options]="opcoesIndicadorPor[i] || vazio" [(ngModel)]="ind.calculo.dividir" placeholder="Indicador"
                    appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
                </div>
                <div class="me-campo">
                  <label [for]="'i-por-' + i">Por</label>
                  <p-dropdown [inputId]="'i-por-' + i" [options]="opcoesIndicadorPor[i] || vazio" [(ngModel)]="ind.calculo.por" placeholder="Indicador"
                    appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
                </div>
              </ng-container>
              <div class="me-campo">
                <label [for]="'i-fmt-' + i">Formato</label>
                <p-dropdown [inputId]="'i-fmt-' + i" [options]="opcoesFormato" [ngModel]="ind.formato || null" (ngModelChange)="definir(ind, 'formato', $event)"
                  appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
              </div>
              <div class="me-campo">
                <label [for]="'i-cmp-' + i">Comparar com</label>
                <p-dropdown [inputId]="'i-cmp-' + i" [options]="opcoesComparar" [ngModel]="ind.comparar || null" (ngModelChange)="definir(ind, 'comparar', $event)"
                  appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
              </div>
            </div>
          </article>
        </div>
      </section>

      <section class="rd-painel me-secao" *ngIf="aba === 'graficos'">
        <div class="me-secao-topo">
          <div>
            <div class="rd-painel-titulo">Gráficos</div>
            <p class="me-dica">Calculados no banco sobre todas as linhas filtradas, não só as que aparecem na tabela.</p>
          </div>
          <button pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-plus" label="Adicionar gráfico" *ngIf="podeEditar && fonteAtual"
            (click)="adicionarGrafico()"></button>
        </div>

        <div class="me-vazio-bloco" *ngIf="!modelo.graficos.length">Nenhum gráfico. Clique numa coluna à esquerda para criar um gráfico por ela.</div>

        <article class="me-cartao" *ngFor="let g of modelo.graficos; let i = index">
          <div class="me-cartao-topo">
            <div class="me-ordem">
              <button type="button" aria-label="Subir" [disabled]="!podeEditar || i === 0" (click)="mover(modelo.graficos, i, -1)"><i class="pi pi-chevron-up"></i></button>
              <button type="button" aria-label="Descer" [disabled]="!podeEditar || i === modelo.graficos.length - 1" (click)="mover(modelo.graficos, i, 1)"><i class="pi pi-chevron-down"></i></button>
            </div>
            <div class="me-filtro-titulo">
              <strong>{{ g.titulo || 'Sem título' }}</strong>
              <code>{{ g.id }}</code>
            </div>
            <button type="button" class="me-remover" aria-label="Remover gráfico" [disabled]="!podeEditar" (click)="removerGrafico(i)"><i class="pi pi-times"></i></button>
          </div>
          <div class="me-form-grade">
            <div class="me-campo">
              <label [for]="'gr-tit-' + i">Título</label>
              <input [id]="'gr-tit-' + i" type="text" pInputText [ngModel]="g.titulo" (ngModelChange)="definir(g, 'titulo', $event)" [disabled]="!podeEditar" />
            </div>
            <div class="me-campo">
              <label [for]="'gr-tipo-' + i">Tipo</label>
              <p-dropdown [inputId]="'gr-tipo-' + i" [options]="opcoesTipoGrafico" [ngModel]="g.tipo" (ngModelChange)="definirTipoGrafico(g, $event)" appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
            </div>
            <div class="me-campo">
              <label [for]="'gr-cat-' + i">{{ g.tipo === 'pizza' || g.tipo === 'rosca' ? 'Fatias por' : 'Eixo por' }}</label>
              <p-dropdown [inputId]="'gr-cat-' + i" [options]="categoriasDoGrafico(g)" [ngModel]="g.categoria" (ngModelChange)="definirCategoriaGrafico(g, $event)" [filter]="true"
                [emptyMessage]="g.tipo === 'pizza' || g.tipo === 'rosca' ? 'A fonte não tem coluna de texto para virar fatia' : 'Nenhuma coluna serve para este tipo'"
                appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
            </div>
            <div class="me-campo" *ngIf="colunaTemporal(g.categoria)">
              <label [for]="'gr-dt-' + i">Juntar datas</label>
              <p-dropdown [inputId]="'gr-dt-' + i" [options]="opcoesAgruparData" [(ngModel)]="g.agruparData" appendTo="body" [disabled]="!podeEditar"
                styleClass="me-cheio"></p-dropdown>
            </div>
            <div class="me-campo" *ngIf="!colunaTemporal(g.categoria)">
              <label [for]="'gr-ord-' + i">Ordem</label>
              <p-dropdown [inputId]="'gr-ord-' + i" [options]="opcoesOrdemGrafico" [ngModel]="g.ordem || null" (ngModelChange)="definir(g, 'ordem', $event)"
                appendTo="body" [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
            </div>
            <div class="me-campo">
              <label [for]="'gr-fun-' + i">Cálculo</label>
              <p-dropdown [inputId]="'gr-fun-' + i" [options]="opcoesFuncao" [ngModel]="g.metrica.funcao" (ngModelChange)="definirFuncaoGrafico(g, $event)" appendTo="body" [disabled]="!podeEditar"
                styleClass="me-cheio"></p-dropdown>
            </div>
            <div class="me-campo">
              <label [for]="'gr-col-' + i">Coluna</label>
              <p-dropdown [inputId]="'gr-col-' + i" [options]="colunasDaMetrica(g)" [ngModel]="g.metrica.coluna || null" (ngModelChange)="definir(g.metrica, 'coluna', $event)"
                [showClear]="g.metrica.funcao === 'COUNT'" [placeholder]="g.metrica.funcao === 'COUNT' ? 'Todas as linhas' : 'Escolha'" [filter]="true" appendTo="body"
                [disabled]="!podeEditar" styleClass="me-cheio"></p-dropdown>
            </div>
            <div class="me-campo">
              <label [for]="'gr-lim-' + i">Mostrar até</label>
              <input [id]="'gr-lim-' + i" type="number" min="1" max="50" pInputText [ngModel]="g.limite" (ngModelChange)="definirLimiteGrafico(g, $event)"
                [placeholder]="temporalGrafico(g) ? '50 pontos' : '10 itens'" [disabled]="!podeEditar" />
            </div>
            <div class="me-campo me-campo-marca" *ngIf="!temporalGrafico(g)">
              <label class="me-marca">
                <p-checkbox [binary]="true" [ngModel]="g.outros !== false" (ngModelChange)="definir(g, 'outros', $event ? null : false)" [disabled]="!podeEditar"></p-checkbox>
                Somar o resto em "Outros"
              </label>
            </div>
          </div>
        </article>
      </section>

      <section class="rd-painel me-secao" *ngIf="aba === 'layout'">
        <div class="me-secao-topo">
          <div>
            <div class="rd-painel-titulo">Layout</div>
            <p class="me-dica">A ordem e a largura dos blocos no relatório. Dois blocos de metade seguidos ficam lado a lado.</p>
          </div>
          <button pButton type="button" class="p-button-text p-button-sm" icon="pi pi-replay" label="Voltar ao padrão" *ngIf="podeEditar && modelo.layout.length"
            (click)="layoutPadrao()"></button>
        </div>
        <div class="me-layout">
          <div class="me-bloco" *ngFor="let b of layoutEfetivo; let i = index; let primeiro = first; let ultimo = last"
            [class.me-bloco-metade]="b.largura === 'metade'" [ngClass]="'me-bloco-' + b.bloco">
            <div class="me-bloco-topo">
              <i class="pi" [ngClass]="b.icone"></i>
              <div class="me-filtro-titulo">
                <strong>{{ b.rotulo }}</strong>
                <code>{{ b.detalhe }}</code>
              </div>
            </div>
            <div class="me-bloco-acoes">
              <div class="me-bloco-mover">
                <button type="button" [attr.aria-label]="'Mover ' + b.rotulo + ' para antes'" [disabled]="!podeEditar || primeiro" (click)="moverBloco(i, -1)">
                  <i class="pi pi-arrow-left"></i>
                </button>
                <button type="button" [attr.aria-label]="'Mover ' + b.rotulo + ' para depois'" [disabled]="!podeEditar || ultimo" (click)="moverBloco(i, 1)">
                  <i class="pi pi-arrow-right"></i>
                </button>
              </div>
              <p-selectButton class="me-largura-layout" [options]="opcoesLargura" [ngModel]="b.largura" (ngModelChange)="definirLargura(i, $event)" optionLabel="label"
                optionValue="value" [disabled]="!podeEditar">
                <ng-template let-item pTemplate>
                  <span class="me-largura-icone" [class.me-largura-icone-metade]="item.value === 'metade'" [title]="'Largura ' + item.label.toLowerCase()"
                    [attr.aria-label]="'Largura ' + item.label.toLowerCase()"><i></i><i></i></span>
                </ng-template>
              </p-selectButton>
            </div>
          </div>
        </div>
      </section>

      <section class="rd-painel me-secao me-json" *ngIf="aba === 'json'">
        <div class="rd-painel-titulo">
          JSON do modelo
          <span class="rd-painel-extra">validado pelo relatorio.v1.schema.json</span>
          <button pButton type="button" class="p-button-text p-button-sm" label="Formatar" [disabled]="!!jsonInvalido" (click)="formatar()"></button>
        </div>
        <p class="me-dica">As outras abas editam este mesmo JSON. O que mudar aqui aparece nelas.</p>
        <div class="rd-erros me-json-erro" *ngIf="jsonInvalido">JSON inválido: {{ jsonInvalido }}</div>
        <habil-editor-codigo [valor]="modeloTexto" (valorChange)="textoAlterado($event)" linguagem="json" altura="calc(100vh - 420px)"
          [schemaJson]="schemaModelo" [somenteLeitura]="!podeEditar" nomeArquivo="modelo.json"></habil-editor-codigo>
      </section>
    </main>
  </div>

  <div class="me-distribuicao" *ngIf="aba === 'distribuicao'">
    <section class="rd-painel me-secao">
      <div class="rd-painel-titulo">Quem recebe este relatório</div>
      <div class="me-modos" role="radiogroup" aria-label="Quem recebe">
        <button type="button" role="radio" [attr.aria-checked]="distribuicao.distribuicao === 'TODOS'" [class.ativo]="distribuicao.distribuicao === 'TODOS'"
          [disabled]="!podePublicar" (click)="distribuicao.distribuicao = 'TODOS'">
          <strong>Todos os clientes</strong><span>Vai no catálogo de todo mundo.</span>
        </button>
        <button type="button" role="radio" [attr.aria-checked]="distribuicao.distribuicao === 'ROTINAS'" [class.ativo]="distribuicao.distribuicao === 'ROTINAS'"
          [disabled]="!podePublicar" (click)="distribuicao.distribuicao = 'ROTINAS'">
          <strong>Quem tem as rotinas</strong><span>Só clientes com as rotinas liberadas na licença.</span>
        </button>
        <button type="button" role="radio" [attr.aria-checked]="distribuicao.distribuicao === 'CNPJS'" [class.ativo]="distribuicao.distribuicao === 'CNPJS'"
          [disabled]="!podePublicar" (click)="distribuicao.distribuicao = 'CNPJS'">
          <strong>Clientes escolhidos</strong><span>Só os CNPJs da lista. Não chega em mais ninguém.</span>
        </button>
      </div>

      <div class="me-campo" *ngIf="distribuicao.distribuicao === 'ROTINAS'">
        <label for="dist-rotinas">Rotinas</label>
        <p-multiSelect inputId="dist-rotinas" [options]="rotinas" [(ngModel)]="distribuicao.rotinas" [filter]="true" display="chip"
          placeholder="Adicionar rotina" appendTo="body" [disabled]="!podePublicar" styleClass="me-cheio"></p-multiSelect>
        <div class="me-exigir">
          <span>Com mais de uma rotina, exigir</span>
          <p-selectButton [options]="opcoesExigir" [(ngModel)]="distribuicao.exigirTodasRotinas" optionLabel="label" optionValue="value"
            [disabled]="!podePublicar"></p-selectButton>
        </div>
      </div>

      <div class="me-campo" *ngIf="distribuicao.distribuicao === 'CNPJS'">
        <label for="dist-cnpjs">Clientes</label>
        <habil-busca-clientes inputId="dist-cnpjs" [(cnpjs)]="distribuicao.cnpjs" [disabled]="!podePublicar"></habil-busca-clientes>
        <small>Busque pelo nome ou CPF/CNPJ. Para colar vários CPF/CNPJs de uma vez, separe por vírgula e tecle Enter.</small>
      </div>

      <div class="me-campo">
        <span class="me-rotulo">Softwares</span>
        <div class="me-softwares">
          <label class="me-marca" *ngFor="let s of softwares">
            <p-checkbox [binary]="true" [ngModel]="distribuicao.softwares.includes(s)" (ngModelChange)="alternarSoftware(s, $event)"
              [disabled]="!podePublicar"></p-checkbox>
            {{ s }}
          </label>
        </div>
        <small>Sem nenhum marcado, vale para todos os softwares.</small>
      </div>

      <div class="me-acoes">
        <button pButton type="button" label="Salvar distribuição" icon="pi pi-check" *ngIf="podePublicar" (click)="salvarDistribuicao()"></button>
      </div>
    </section>

    <aside class="me-lateral">
      <section class="rd-painel">
        <div class="rd-painel-titulo">Hoje este modelo vai para</div>
        <p class="me-resumo">{{ resumoDistribuicao }}.</p>
        <div class="me-dica">
          Publicada: {{ info.versaoPublicada ? 'v' + info.versaoPublicada : 'nenhuma' }}
          <ng-container *ngIf="info.versaoPiloto"> · piloto v{{ info.versaoPiloto }} para {{ info.cnpjsPiloto?.join(', ') }}</ng-container>
        </div>
        <div class="me-dica">Os clientes pegam a versão nova na próxima consulta ao catálogo. Não tem botão "Atualizar".</div>
        <div class="me-acoes">
          <button pButton type="button" class="p-button-outlined p-button-secondary p-button-sm" label="Arquivar" *ngIf="podePublicar && info.status !== 'ARQUIVADO'"
            (click)="arquivar(true)"></button>
          <button pButton type="button" class="p-button-outlined p-button-sm" label="Reativar" *ngIf="podePublicar && info.status === 'ARQUIVADO'"
            (click)="arquivar(false)"></button>
          <button pButton type="button" class="p-button-text p-button-danger p-button-sm" label="Excluir" *ngIf="podeExcluir"
            (click)="excluir()"></button>
        </div>
      </section>
      <div class="rd-info">
        <strong>Distribuição não é permissão.</strong> Aqui você escolhe quem recebe o relatório. Dentro do cliente, quem pode rodar continua sendo decidido pelo
        grupo de acesso do usuário.
      </div>
      <section class="rd-painel" *ngIf="fonteAtual">
        <div class="rd-painel-titulo">A fonte exige</div>
        <div class="me-dica" *ngIf="fonteAtual.rotinaExigida"><i class="pi pi-lock"></i> Rotina <strong>{{ fonteAtual.rotinaExigida }}</strong>. Usuário sem ela no grupo não vê o relatório, mesmo que o cliente o receba.</div>
        <div class="me-dica" *ngIf="!fonteAtual.rotinaExigida">Nenhuma rotina: qualquer usuário com acesso a relatórios roda.</div>
      </section>
    </aside>
  </div>

  <section class="rd-painel me-secao" *ngIf="aba === 'versoes'">
    <p-table [value]="versoes" styleClass="p-datatable-sm">
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 90px">Versão</th>
          <th style="width: 110px">Fonte</th>
          <th>Publicada por</th>
          <th>Notas</th>
          <th style="width: 150px">Situação</th>
          <th style="width: 220px"></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-v>
        <tr>
          <td><strong>v{{ v.versao }}</strong></td>
          <td>v{{ v.fonteVersao }}</td>
          <td>{{ v.publicadoPor }} · {{ v.publicadoEm | date: 'dd/MM/yyyy HH:mm' }}</td>
          <td>{{ v.notas }}</td>
          <td>
            <span class="situacao situacao-publicado" *ngIf="v.publicada">Publicada</span>
            <span class="situacao situacao-piloto" *ngIf="v.piloto">Piloto</span>
          </td>
          <td>
            <button pButton type="button" class="p-button-text p-button-sm" label="Comparar" (click)="verVersao(v)"></button>
            <button pButton type="button" class="p-button-text p-button-sm" label="Republicar" *ngIf="podePublicar && !v.publicada" (click)="republicar(v)"></button>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">Nenhuma versão publicada ainda.</td>
        </tr>
      </ng-template>
    </p-table>
  </section>
</div>

<p-sidebar [(visible)]="mostrarPrevia" position="right" styleClass="me-gaveta" [showCloseIcon]="false" ariaCloseLabel="Fechar prévia">
  <section class="me-previa" aria-label="Prévia" *ngIf="modelo">
      <div class="me-previa-topo">
        <div class="me-previa-titulo">
          <h2>Prévia</h2>
          <span class="me-previa-base" [title]="baseAtual">{{ baseAtual || 'Nenhuma base: escolha no topo da tela' }}</span>
        </div>
        <button pButton type="button" icon="pi pi-refresh" class="p-button-outlined" label="Rodar de novo" [loading]="rodandoPrevia" (click)="rodarPrevia()"></button>
        <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-secondary p-button-rounded" aria-label="Fechar prévia"
          (click)="mostrarPrevia = false"></button>
      </div>

      <div class="me-teste" *ngIf="modelo.filtros.length">
        <div class="me-teste-titulo">
          Valores de teste
          <a href="javascript:void(0)" class="me-limpar" *ngIf="(valoresPrevia | keyvalue).length" (click)="limparPrevia()">limpar</a>
        </div>
        <div class="me-teste-grade">
          <div class="me-teste-campo" *ngFor="let f of modelo.filtros; let i = index" [ngSwitch]="campoPrevia(f)"
            [class.me-teste-largo]="campoPrevia(f) === 'periodo' || campoPrevia(f) === 'faixaData'">
            <label [for]="'p-' + i">{{ rotuloFiltro(f) }}</label>
            <div class="me-teste-par" *ngSwitchCase="'periodo'">
              <p-dropdown [inputId]="'p-' + i" [options]="opcoesPeriodoTeste" [ngModel]="modoPeriodo(chaveFiltro(f))"
                (ngModelChange)="definirModoPeriodo(chaveFiltro(f), $event)" [showClear]="true" [placeholder]="padraoPrevia(f)" appendTo="body"
                styleClass="me-periodo"></p-dropdown>
              <ng-container *ngIf="modoPeriodo(chaveFiltro(f)) === 'datas'">
                <input type="date" pInputText [ngModel]="valorPrevia(chaveFiltro(f), 'inicio')" (ngModelChange)="definirPrevia(chaveFiltro(f), $event, 'inicio')"
                  aria-label="Início" />
                <span>a</span>
                <input type="date" pInputText [ngModel]="valorPrevia(chaveFiltro(f), 'fim')" (ngModelChange)="definirPrevia(chaveFiltro(f), $event, 'fim')"
                  aria-label="Fim" />
              </ng-container>
            </div>
            <div class="me-teste-par" *ngSwitchCase="'faixaData'">
              <input [id]="'p-' + i" type="date" pInputText [ngModel]="valorPrevia(chaveFiltro(f), 'de')" (ngModelChange)="definirPrevia(chaveFiltro(f), $event, 'de')"
                aria-label="De" />
              <span>a</span>
              <input type="date" pInputText [ngModel]="valorPrevia(chaveFiltro(f), 'ate')" (ngModelChange)="definirPrevia(chaveFiltro(f), $event, 'ate')"
                aria-label="Até" />
            </div>
            <div class="me-teste-par" *ngSwitchCase="'faixaNumero'">
              <input [id]="'p-' + i" type="number" step="any" pInputText [ngModel]="valorPrevia(chaveFiltro(f), 'de')"
                (ngModelChange)="definirPrevia(chaveFiltro(f), $event, 'de')" placeholder="de" />
              <span>a</span>
              <input type="number" step="any" pInputText [ngModel]="valorPrevia(chaveFiltro(f), 'ate')" (ngModelChange)="definirPrevia(chaveFiltro(f), $event, 'ate')"
                placeholder="até" />
            </div>
            <p-dropdown *ngSwitchCase="'opcoes'" [inputId]="'p-' + i" [options]="opcoesParametro(f)" [ngModel]="valorPrevia(chaveFiltro(f))"
              (ngModelChange)="definirPrevia(chaveFiltro(f), $event)" [showClear]="true" [placeholder]="padraoPrevia(f)" appendTo="body" styleClass="me-cheio"></p-dropdown>
            <p-dropdown *ngSwitchCase="'booleano'" [inputId]="'p-' + i" [options]="opcoesBooleano" [ngModel]="valorPrevia(chaveFiltro(f))"
              (ngModelChange)="definirPrevia(chaveFiltro(f), $event)" [showClear]="true" [placeholder]="padraoPrevia(f)" appendTo="body" styleClass="me-cheio"></p-dropdown>
            <input *ngSwitchCase="'data'" [id]="'p-' + i" type="date" pInputText [ngModel]="valorPrevia(chaveFiltro(f))"
              (ngModelChange)="definirPrevia(chaveFiltro(f), $event)" />
            <input *ngSwitchCase="'inteiro'" [id]="'p-' + i" type="number" pInputText [ngModel]="valorPrevia(chaveFiltro(f))"
              (ngModelChange)="definirPrevia(chaveFiltro(f), $event)" [placeholder]="padraoPrevia(f)" />
            <input *ngSwitchCase="'decimal'" [id]="'p-' + i" type="number" step="any" pInputText [ngModel]="valorPrevia(chaveFiltro(f))"
              (ngModelChange)="definirPrevia(chaveFiltro(f), $event)" [placeholder]="padraoPrevia(f)" />
            <p-chips *ngSwitchCase="'listaTexto'" [inputId]="'p-' + i" [ngModel]="valorPrevia(chaveFiltro(f)) || vazio" (ngModelChange)="definirPrevia(chaveFiltro(f), $event)"
              [addOnBlur]="true" [allowDuplicate]="false" [placeholder]="padraoPrevia(f)" styleClass="me-cheio"></p-chips>
            <p-chips *ngSwitchCase="'listaInteiro'" [inputId]="'p-' + i" [ngModel]="valorPrevia(chaveFiltro(f)) || vazio" (ngModelChange)="definirPrevia(chaveFiltro(f), $event)"
              [addOnBlur]="true" [allowDuplicate]="false" [placeholder]="padraoPrevia(f)" styleClass="me-cheio"></p-chips>
            <input *ngSwitchDefault [id]="'p-' + i" type="text" pInputText [ngModel]="valorPrevia(chaveFiltro(f))" (ngModelChange)="definirPrevia(chaveFiltro(f), $event)"
              [placeholder]="padraoPrevia(f)" />
          </div>
        </div>
      </div>

      <div class="me-previa-estado me-previa-erro" *ngIf="erroPrevia"><i class="pi pi-exclamation-circle"></i>{{ erroPrevia }}</div>
      <ul class="rd-erros" *ngIf="validacao?.erros?.length">
        <li *ngFor="let e of validacao.erros">{{ e }}</li>
      </ul>
      <ul class="rd-avisos" *ngIf="validacao?.avisos?.length">
        <li *ngFor="let a of validacao.avisos">{{ a }}</li>
      </ul>

      <div class="me-previa-resultado" [class.me-previa-velha]="rodandoPrevia">
        <habil-resultado-relatorio *ngIf="resultado" [resultado]="resultado"></habil-resultado-relatorio>
        <div class="me-previa-vazia" *ngIf="!resultado && !erroPrevia">
          <i class="pi pi-play"></i>
          <span *ngIf="baseAtual">Rodando a prévia…</span>
          <span *ngIf="!baseAtual">Escolha a base no topo para ver o relatório com dados reais.</span>
        </div>
      </div>
      <div class="me-nota"><i class="pi pi-lock"></i> Roda na base escolhida, numa transação somente leitura. Os valores de teste rodam a prévia de novo sozinhos.</div>
  </section>
</p-sidebar>

<p-sidebar [(visible)]="mostrarIa" position="right" styleClass="me-gaveta me-gaveta-ia" [showCloseIcon]="false" ariaCloseLabel="Fechar">
  <section class="me-ia" *ngIf="modelo">
    <div class="me-previa-topo">
      <div class="me-previa-titulo">
        <h2>Ajustar com IA</h2>
        <span class="me-previa-base">Diga o que mudar neste modelo. Você revisa e aplica no editor; nada é salvo sozinho.</span>
      </div>
      <button pButton type="button" icon="pi pi-times" class="p-button-text p-button-secondary p-button-rounded" aria-label="Fechar" (click)="mostrarIa = false"></button>
    </div>

    <div class="me-ia-proposta" *ngIf="propostaIa">
      <div class="me-ia-proposta-topo">
        <strong>Proposta pronta</strong>
        <span class="me-ia-erro" *ngIf="propostaIa.erros?.length">{{ propostaIa.erros.length }} problema(s): peça a correção na conversa</span>
      </div>
      <dl class="me-ia-resumo">
        <ng-container *ngFor="let r of resumoIa">
          <dt>{{ r.rotulo }}</dt>
          <dd>{{ r.valor }}</dd>
        </ng-container>
      </dl>
      <div class="rd-avisos me-ia-fonte" *ngIf="propostaIa.fonte">
        A IA também mudou a fonte <code>{{ propostaIa.fonte.chave }}</code>, porque o pedido precisa de colunas que ela não tem. Aplique o SQL abaixo na fonte e salve
        uma versão antes de publicar o modelo.
        <habil-editor-codigo [valor]="propostaIa.fonte.sql" linguagem="sql" altura="180px" [somenteLeitura]="true" nomeArquivo="fonte-ajuste.sql"></habil-editor-codigo>
      </div>
      <div class="me-acoes">
        <button pButton type="button" class="p-button-text p-button-secondary" label="Descartar" (click)="descartarIa()"></button>
        <button pButton type="button" icon="pi pi-check" label="Aplicar no editor" [disabled]="!!propostaIa.erros?.length" (click)="aplicarIa()"></button>
      </div>
    </div>

    <div class="me-ia-conversa">
      <habil-conversa-ia [mensagens]="mensagensIa" [ocupado]="pensandoIa" rotuloCampo="O que mudar"
        placeholder="Ex.: agrupa por vendedor, tira o desconto e mostra um gráfico de barras com o total por UF"
        [vazio]="service.base ? 'A IA conhece este modelo, a fonte e a estrutura do banco. Peça como pediria para alguém da equipe.' : 'Escolha a base no topo: a IA lê a estrutura do banco dessa base.'"
        (enviar)="enviarIa($event)"></habil-conversa-ia>
    </div>
  </section>
</p-sidebar>

<p-dialog [header]="'Publicar v' + proximaVersao" [(visible)]="mostrarPublicar" [modal]="true" [style]="{ width: '560px' }">
  <div class="me-publicar">
    <label class="me-marca">
      <p-checkbox [(ngModel)]="publicacao.piloto" [binary]="true"></p-checkbox>
      Publicar primeiro para um piloto
    </label>
    <small *ngIf="publicacao.piloto">A versão nova vai só para estes clientes. Os demais continuam na versão atual até você abrir para todos.</small>
    <ng-container *ngIf="publicacao.piloto">
      <label for="pub-cnpjs">Clientes do piloto</label>
      <habil-busca-clientes inputId="pub-cnpjs" [(cnpjs)]="publicacao.cnpjsPiloto"></habil-busca-clientes>
    </ng-container>
    <small *ngIf="!publicacao.piloto">Vai para {{ resumoDistribuicao }}, conforme a aba Distribuição.</small>
    <label for="pub-notas">O que mudou</label>
    <textarea id="pub-notas" pInputTextarea rows="3" [(ngModel)]="publicacao.notas"></textarea>
    <small>O rascunho é salvo, validado contra a versão atual da fonte e congelado junto com ela.</small>
  </div>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Cancelar" (click)="mostrarPublicar = false"></button>
    <button pButton type="button" [label]="publicacao.piloto ? 'Publicar para o piloto' : 'Publicar'" icon="pi pi-send" (click)="publicar()"></button>
  </ng-template>
</p-dialog>

<p-dialog [header]="'Versão ' + versaoVista?.versao + ' × editor'" [(visible)]="mostrarVersao" [modal]="true" [style]="{ width: '90vw' }" [maximizable]="true">
  <habil-editor-diff *ngIf="mostrarVersao" [original]="versaoVistaTexto" [modificado]="modeloAtualTexto" linguagem="json" altura="60vh"></habil-editor-diff>
  <ng-template pTemplate="footer">
    <button pButton type="button" class="p-button-text" label="Fechar" (click)="mostrarVersao = false"></button>
    <button pButton type="button" label="Carregar esta versão no editor" *ngIf="podeEditar" (click)="carregarVersaoNoEditor()"></button>
  </ng-template>
</p-dialog>
